import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, CHANNELS } from "@/lib/api";
import { Modal } from "@/components/ui-bits";
import { TagInput } from "@/components/TagInput";

const blank = { name: "", email: "", phone: "", goal: "Strength", notes: "", sessionsPerWeek: 3, preferredTimes: "06:00-09:00, 17:00-19:00", preferredChannel: "WHATSAPP", motivationOn: true, active: true, password: "", injuries: [] };

export const ClientForm = ({ client, onClose, onSaved }) => {
  const edit = !!client;
  const [f, setF] = useState(edit ? {
    ...blank, name: client.name, email: client.user?.email || "", phone: client.user?.phone || "", goal: client.goal || "", notes: client.notes || "",
    sessionsPerWeek: client.sessionsPerWeek, preferredTimes: (client.preferredTimes || []).join(", "),
    preferredChannel: client.preferredChannel, motivationOn: client.motivationOn, active: client.active, injuries: client.injuries || [],
  } : blank);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    const payload = {
      name: f.name.trim(), phone: f.phone.trim() || null, goal: f.goal.trim() || null, notes: f.notes.trim() || null,
      sessionsPerWeek: Number(f.sessionsPerWeek), preferredTimes: f.preferredTimes.split(",").map((s) => s.trim()).filter(Boolean),
      preferredChannel: f.preferredChannel, motivationOn: f.motivationOn, injuries: f.injuries,
    };
    try {
      const r = edit
        ? await api.patch(`/clients/${client.id}`, { ...payload, email: f.email.trim(), active: f.active })
        : await api.post("/clients", { ...payload, email: f.email.trim(), password: f.password || null });
      toast.success(edit ? "Profile updated" : `${r.data.name} added — login: ${f.email.trim()} / ${f.password || "password123"}`);
      onSaved(r.data);
    } catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };

  return (
    <Modal title={edit ? "EDIT CLIENT" : "NEW CLIENT"} sub={edit ? "Cadence and preferred times feed the Sunday auto-scheduler." : "Creates the login + profile. Default password is password123."} onClose={onClose} testId="client-form-modal">
      <form onSubmit={save}>
        <div className="frow">
          <div><label>Full name</label><input required value={f.name} onChange={set("name")} data-testid="client-name-input" /></div>
          <div><label>Phone (E.164, for WhatsApp/SMS)</label><input placeholder="+6591234567" value={f.phone} onChange={set("phone")} data-testid="client-phone-input" /></div>
        </div>
        <div className="frow">
          <div><label>Email (login &amp; email delivery)</label><input required type="email" value={f.email} onChange={set("email")} data-testid="client-email-input" /></div>
          {!edit && <div><label>Password (optional)</label><input placeholder="password123" value={f.password} onChange={set("password")} data-testid="client-password-input" /></div>}
        </div>
        <div className="frow">
          <div><label>Goal</label><input placeholder="Strength, Fat loss…" value={f.goal} onChange={set("goal")} data-testid="client-goal-input" /></div>
          <div><label>Sessions / week</label><input type="number" min="1" max="7" value={f.sessionsPerWeek} onChange={set("sessionsPerWeek")} data-testid="client-cadence-input" /></div>
        </div>
        <div className="frow">
          <div><label>Preferred windows (HH:MM-HH:MM, comma separated)</label><input value={f.preferredTimes} onChange={set("preferredTimes")} data-testid="client-times-input" /></div>
          <div><label>Preferred channel</label>
            <select value={f.preferredChannel} onChange={set("preferredChannel")} data-testid="client-channel-select">{CHANNELS.map((c) => <option key={c}>{c}</option>)}</select></div>
        </div>
        <label>Injuries / issues · the matching recovery plan is pre-selected when you apply a deload</label>
        <TagInput value={f.injuries} onChange={(v) => setF({ ...f, injuries: v })} testId="client-injuries" />
        <label>Private trainer notes</label>
        <textarea rows={2} value={f.notes} onChange={set("notes")} data-testid="client-notes-input" />
        <div style={{ display: "flex", gap: 20, marginTop: 12, fontSize: 13 }}>
          <label style={{ display: "flex", alignItems: "center", gap: 6, margin: 0, color: "var(--ink)" }}>
            <input type="checkbox" checked={f.motivationOn} onChange={set("motivationOn")} data-testid="client-motivation-checkbox" /> Daily motivation</label>
          {edit && <label style={{ display: "flex", alignItems: "center", gap: 6, margin: 0, color: "var(--ink)" }}>
            <input type="checkbox" checked={f.active} onChange={set("active")} data-testid="client-active-checkbox" /> Active</label>}
        </div>
        <div className="mfoot">
          <button type="button" className="btn g" onClick={onClose} data-testid="client-form-cancel">Cancel</button>
          <button className="btn" disabled={busy} data-testid="client-form-save">{edit ? "Save changes" : "Add client"}</button>
        </div>
      </form>
    </Modal>
  );
};
